// src/shared/analytics/ga4.ts

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

type GaValue = string | number | boolean | null | undefined;
export type GAEventParams = Record<string, GaValue>;

const isDev = process.env.NODE_ENV !== 'production';

function sanitizeParams(params?: GAEventParams): GAEventParams {
  if (!params) return {};

  const blockedKeys = new Set([
    'telegram_chat_id',
    'access_token',
    'refresh_token',
    'authorization',
    'password',
    'email',
    'phone',
  ]);

  const sanitized: GAEventParams = {};

  Object.entries(params).forEach(([key, value]) => {
    if (blockedKeys.has(key)) return;
    if (value === undefined) return;
    sanitized[key] = typeof value === 'string' ? value.slice(0, 100) : value;
  });

  return sanitized;
}

export function trackEvent(eventName: string, params?: GAEventParams) {
  const payload = sanitizeParams({
    ...params,
    app_env: process.env.NODE_ENV ?? 'development',
    ts: Date.now(),
  });

  if (isDev) {
    console.info('[GA4]', eventName, payload);
  }

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, payload);
  }
}

export function trackPageView(pageName: string, params?: GAEventParams) {
  trackEvent('screen_view', {
    screen_name: pageName,
    ...params,
  });
}